import {h, Fragment} from "preact"
import { translatedText } from "./utils/translatedText";

export default function PopularSites() {
  const root = typeof window !== "undefined" && window.Shopify?.routes?.root
    ? window.Shopify.routes.root
    : "/"; 

  return (
    <>
      <p className="text-13-120 uppercase text-black-55 mb-16 lg:mb-12">
        {translatedText("popularSites")}
      </p>

      <a href={`${root}blogs/guides/fit-guides`} className="block text-13-120 mb-12 text-black-55">
        {translatedText("fitGuides")}
      </a>

      <a href={`${root}pages/contact`} className="block text-13-120 mb-12 text-black-55">
        {translatedText("contact")}
      </a>

      <a href={`${root}pages/faq`} className="block text-13-120 mb-12 text-black-55">
        {translatedText("faq")}
      </a>

      <a href={`${root}pages/shipping-and-delivery`} className="block text-13-120 mb-12 text-black-55">
        {translatedText("shippingDelivery")}
      </a>

      <a href={`${root}pages/returns`} className="block text-13-120 mb-12 text-black-55">
        {translatedText("returns")} 
      </a>
    </>
  );
}
